import { type ReactNode } from 'react';
import { Card } from 'react-bootstrap';
import classNames from 'classnames';
import Background from '@/components/common/Background';
import SoftBadge from '@/components/common/SoftBadge';
import corner1 from '@/assets/img/icons/spot-illustrations/corner-1.png';
import corner2 from '@/assets/img/icons/spot-illustrations/corner-2.png';
import corner3 from '@/assets/img/icons/spot-illustrations/corner-3.png';
import corner4 from '@/assets/img/icons/spot-illustrations/corner-4.png';
import corner5 from '@/assets/img/icons/spot-illustrations/corner-5.png';

const CORNER_IMAGES = [corner1, corner2, corner3, corner4, corner5];

export function KpiStatCard({
  label,
  value,
  /** Small, dim text shown right after the number (e.g. an English metric name). */
  valueAnnotation,
  valueAnnotationClassName,
  subtext,
  valueClassName,
  badgeText,
  badgeBg = 'primary',
  valueBadge,
  imageIndex = 0,
  className,
}: {
  label: ReactNode;
  value: string | number;
  valueAnnotation?: ReactNode;
  valueAnnotationClassName?: string;
  subtext?: ReactNode;
  valueClassName?: string;
  badgeText?: string;
  badgeBg?: string;
  valueBadge?: ReactNode;
  imageIndex?: number;
  className?: string;
}) {
  const image = CORNER_IMAGES[imageIndex % CORNER_IMAGES.length];

  return (
    <Card className={classNames('h-100 overflow-hidden', className)}>
      <Background image={image} className="bg-card" />
      <Card.Body className="position-relative">
        <h6 className="mb-3">
          {label}
          {badgeText ? (
            <SoftBadge bg={badgeBg} pill className="ms-2">
              {badgeText}
            </SoftBadge>
          ) : null}
        </h6>
        <div className="d-flex align-items-center gap-2 flex-wrap mb-2">
          <div
            className={classNames(
              'display-4 fs-3 fw-normal font-sans-serif text-truncate mb-0',
              valueClassName,
            )}
            style={{ fontVariantNumeric: 'tabular-nums' }}
          >
            {value}
          </div>
          {valueAnnotation ? (
            <span className={classNames('fs--2 text-400 fw-normal', valueAnnotationClassName)}>
              {valueAnnotation}
            </span>
          ) : null}
          {valueBadge ? (
            <span className="flex-shrink-0">{valueBadge}</span>
          ) : null}
        </div>
        {subtext ? <p className="fs--2 text-500 mb-0">{subtext}</p> : null}
      </Card.Body>
    </Card>
  );
}
